import React from "react";
import KitchenSection from "../KitchenSection";
import Sidebar from "../Sidebar";
import styles from './Body.module.css';
import ExpoTile from '../ExpoTile';

const Orders = (props) => {
  const { onPaginateLeft, onPaginateRight, ordersToBeShown, onOrderClick } = props;
  return (
    <div className={styles.tilesContainer}>
      <span className={styles.sideArrow} onClick={onPaginateLeft}>&lt;</span>
      <div className={styles.tileMain}>
        {ordersToBeShown.map((info) => {
          return (
            <div key={`tile-${info.uniqueId}`} onClick={() => onOrderClick(info.uniqueId)} className={styles.tileContainer}>
              <ExpoTile info={info} />
            </div>
          )
        })}
      </div>
      <span className={styles.sideArrow} onClick={onPaginateRight}>&gt;</span>
    </div>
  )
}

const Body = (props) => {
  const { selectedKitchenType } = props;
  const BodyContent = selectedKitchenType === 0 ? Orders : KitchenSection;
  return (
    <div className={styles.container}>
      <Sidebar {...props} />
      <BodyContent {...props} />
    </div>
  )
};

export default Body;